import { render, staticRenderFns } from "./Offcanvas.vue?vue&type=template&id=ae18b4e8&scoped=true"
import script from "./Offcanvas.vue?vue&type=script&lang=js"
export * from "./Offcanvas.vue?vue&type=script&lang=js"
import style0 from "./Offcanvas.vue?vue&type=style&index=0&id=ae18b4e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae18b4e8",
  null
  
)

export default component.exports